<template>
  <div>
    <div class="page-header">
      <span class="h3">{{ $t("categories.plural") }}</span>
      <router-link :to="$t('projects.parent_route')"><span class="h6 text-muted float-right">All {{ $t("projects.plural") }}</span></router-link>
    </div>

    <ul class="mt-2 list-group">
      <draggable class="dragArea list-group" :list="projectAreas" @change="move" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="projectArea in projectAreas" :key="projectArea.id" class="list-group-item js-task-details-collapse-container">
            <span class=" d-flex">
              {{projectArea.name}}                  
              <span class='push-right'>             
                <i class="material-icons small-icon pointer" data-toggle="dropdown">edit</i>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="#" data-toggle="modal" :data-target="'#editProjectAreaModal' + projectArea.id">Edit {{ $t("categories.singular") }}</a>
                  <a class="dropdown-item text-danger" v-if="!projectArea.projects.length && !projectArea.protected" href="#" data-toggle="modal" :data-target="'#deleteProjectAreaModal' + projectArea.id">Delete {{ $t("categories.singular") }}</a>
                </div> 

                <div class="modal fade" :id="'editProjectAreaModal' + projectArea.id">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Update {{ $t("categories.singular") }}</h5>
                      </div>
                      <div class="modal-body">
                        <div class="form-group row align-items-center">
                          <div class="col">
                            <input v-model="projectArea.name" :placeholder="$t('categories.new')" class="form-control">
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="updateProjectArea(projectArea)">Save</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal fade" :id="'deleteProjectAreaModal' + projectArea.id">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Are you sure you want to delete this {{ $t("categories.singular").toLowerCase() }}?</h5>
                      </div>
                      <div class="modal-body">
                        <div> Are you sure you want to delete? -
                          <em>
                            {{projectArea.name}}
                          </em>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="deleteProjectArea(projectArea)">Delete {{ $t("categories.singular") }}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <i class="material-icons pointer ml-1 sort-handle">reorder</i>
              </span>
            </span>          
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
import api from "api";
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  computed: {
    projectAreas: {
      get() {
        return this.$store.state.project_areas.filter(area => {
          return area.file_cabinet === false
        })
      }
    },
  },
  methods: {
    move: function(evt) {
      if(evt.moved){
        api.changeProjectAreaSort(evt.moved.element.id, evt.moved.newIndex)
      }
    },
    deleteProjectArea(project_area) {
      api.deleteProjectArea(project_area.id).then(response => {
        $('body').removeClass('modal-open')
        $(".modal-backdrop").hide();
      });
    },
    updateProjectArea(project_area) {
      if(project_area.name){
        api.updateProjectArea(project_area.id, { name: project_area.name }).then(response => {
          $('#editProjectAreaModal' + project_area.id).modal('hide')
        });
      }
    }
  }  
}
</script>
